enum ProductsAvailabilityRoutes {
  List = '/products-availability',
  Add = '/products-availability/add',
  Edit = '/products-availability/edit/:id',
}

export default ProductsAvailabilityRoutes
